// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "docommand/v1/do_command.proto" (package "docommand.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Favorite DoCommand
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
import { Struct } from "../../google/protobuf/struct";
/**
 * @generated from protobuf message docommand.v1.FavoriteDoCommandItem
 */
export interface FavoriteDoCommandItem {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct input = 3;
     */
    input?: Struct;
    /**
     * @generated from protobuf field: string machine_id = 4;
     */
    machineId: string;
    /**
     * @generated from protobuf field: string resource_name = 5;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: string user_id = 6;
     */
    userId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_on = 7;
     */
    createdOn?: Timestamp;
}
/**
 * @generated from protobuf message docommand.v1.AddFavoriteDoCommandRequest
 */
export interface AddFavoriteDoCommandRequest {
    /**
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Struct input = 2;
     */
    input?: Struct;
    /**
     * @generated from protobuf field: string machine_id = 3;
     */
    machineId: string;
    /**
     * @generated from protobuf field: string resource_name = 4;
     */
    resourceName: string;
}
/**
 * @generated from protobuf message docommand.v1.AddFavoriteDoCommandResponse
 */
export interface AddFavoriteDoCommandResponse {
    /**
     * @generated from protobuf field: docommand.v1.FavoriteDoCommandItem favorite = 1;
     */
    favorite?: FavoriteDoCommandItem;
}
/**
 * @generated from protobuf message docommand.v1.RenameFavoriteDoCommandRequest
 */
export interface RenameFavoriteDoCommandRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
}
/**
 * @generated from protobuf message docommand.v1.RenameFavoriteDoCommandResponse
 */
export interface RenameFavoriteDoCommandResponse {
}
/**
 * @generated from protobuf message docommand.v1.RemoveFavoriteDoCommandRequest
 */
export interface RemoveFavoriteDoCommandRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message docommand.v1.RemoveFavoriteDoCommandResponse
 */
export interface RemoveFavoriteDoCommandResponse {
}
/**
 * @generated from protobuf message docommand.v1.ListFavoriteDoCommandsRequest
 */
export interface ListFavoriteDoCommandsRequest {
    /**
     * @generated from protobuf field: string machine_id = 1;
     */
    machineId: string;
    /**
     * @generated from protobuf field: optional string resource_name = 2;
     */
    resourceName?: string;
}
/**
 * @generated from protobuf message docommand.v1.ListFavoriteDoCommandsResponse
 */
export interface ListFavoriteDoCommandsResponse {
    /**
     * @generated from protobuf field: repeated docommand.v1.FavoriteDoCommandItem favorites = 1;
     */
    favorites: FavoriteDoCommandItem[];
}
/**
 * @generated from protobuf message docommand.v1.ReorderFavoriteDoCommandsRequest
 */
export interface ReorderFavoriteDoCommandsRequest {
    /**
     * @generated from protobuf field: string machine_id = 1;
     */
    machineId: string;
    /**
     * @generated from protobuf field: string resource_name = 2;
     */
    resourceName: string;
    /**
     * Favorite IDs in their new list order.
     *
     * @generated from protobuf field: repeated string ids = 3;
     */
    ids: string[];
}
/**
 * @generated from protobuf message docommand.v1.ReorderFavoriteDoCommandsResponse
 */
export interface ReorderFavoriteDoCommandsResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class FavoriteDoCommandItem$Type extends MessageType<FavoriteDoCommandItem> {
    constructor() {
        super("docommand.v1.FavoriteDoCommandItem", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "input", kind: "message", T: () => Struct },
            { no: 4, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "created_on", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message docommand.v1.FavoriteDoCommandItem
 */
export const FavoriteDoCommandItem = new FavoriteDoCommandItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddFavoriteDoCommandRequest$Type extends MessageType<AddFavoriteDoCommandRequest> {
    constructor() {
        super("docommand.v1.AddFavoriteDoCommandRequest", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "input", kind: "message", T: () => Struct },
            { no: 3, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message docommand.v1.AddFavoriteDoCommandRequest
 */
export const AddFavoriteDoCommandRequest = new AddFavoriteDoCommandRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddFavoriteDoCommandResponse$Type extends MessageType<AddFavoriteDoCommandResponse> {
    constructor() {
        super("docommand.v1.AddFavoriteDoCommandResponse", [
            { no: 1, name: "favorite", kind: "message", T: () => FavoriteDoCommandItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message docommand.v1.AddFavoriteDoCommandResponse
 */
export const AddFavoriteDoCommandResponse = new AddFavoriteDoCommandResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenameFavoriteDoCommandRequest$Type extends MessageType<RenameFavoriteDoCommandRequest> {
    constructor() {
        super("docommand.v1.RenameFavoriteDoCommandRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message docommand.v1.RenameFavoriteDoCommandRequest
 */
export const RenameFavoriteDoCommandRequest = new RenameFavoriteDoCommandRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RenameFavoriteDoCommandResponse$Type extends MessageType<RenameFavoriteDoCommandResponse> {
    constructor() {
        super("docommand.v1.RenameFavoriteDoCommandResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message docommand.v1.RenameFavoriteDoCommandResponse
 */
export const RenameFavoriteDoCommandResponse = new RenameFavoriteDoCommandResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveFavoriteDoCommandRequest$Type extends MessageType<RemoveFavoriteDoCommandRequest> {
    constructor() {
        super("docommand.v1.RemoveFavoriteDoCommandRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message docommand.v1.RemoveFavoriteDoCommandRequest
 */
export const RemoveFavoriteDoCommandRequest = new RemoveFavoriteDoCommandRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveFavoriteDoCommandResponse$Type extends MessageType<RemoveFavoriteDoCommandResponse> {
    constructor() {
        super("docommand.v1.RemoveFavoriteDoCommandResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message docommand.v1.RemoveFavoriteDoCommandResponse
 */
export const RemoveFavoriteDoCommandResponse = new RemoveFavoriteDoCommandResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListFavoriteDoCommandsRequest$Type extends MessageType<ListFavoriteDoCommandsRequest> {
    constructor() {
        super("docommand.v1.ListFavoriteDoCommandsRequest", [
            { no: 1, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message docommand.v1.ListFavoriteDoCommandsRequest
 */
export const ListFavoriteDoCommandsRequest = new ListFavoriteDoCommandsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListFavoriteDoCommandsResponse$Type extends MessageType<ListFavoriteDoCommandsResponse> {
    constructor() {
        super("docommand.v1.ListFavoriteDoCommandsResponse", [
            { no: 1, name: "favorites", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FavoriteDoCommandItem }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message docommand.v1.ListFavoriteDoCommandsResponse
 */
export const ListFavoriteDoCommandsResponse = new ListFavoriteDoCommandsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderFavoriteDoCommandsRequest$Type extends MessageType<ReorderFavoriteDoCommandsRequest> {
    constructor() {
        super("docommand.v1.ReorderFavoriteDoCommandsRequest", [
            { no: 1, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message docommand.v1.ReorderFavoriteDoCommandsRequest
 */
export const ReorderFavoriteDoCommandsRequest = new ReorderFavoriteDoCommandsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReorderFavoriteDoCommandsResponse$Type extends MessageType<ReorderFavoriteDoCommandsResponse> {
    constructor() {
        super("docommand.v1.ReorderFavoriteDoCommandsResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message docommand.v1.ReorderFavoriteDoCommandsResponse
 */
export const ReorderFavoriteDoCommandsResponse = new ReorderFavoriteDoCommandsResponse$Type();
/**
 * @generated ServiceType for protobuf service docommand.v1.FavoriteDoCommandService
 */
export const FavoriteDoCommandService = new ServiceType("docommand.v1.FavoriteDoCommandService", [
    { name: "AddFavoriteDoCommand", options: {}, I: AddFavoriteDoCommandRequest, O: AddFavoriteDoCommandResponse },
    { name: "RenameFavoriteDoCommand", options: {}, I: RenameFavoriteDoCommandRequest, O: RenameFavoriteDoCommandResponse },
    { name: "RemoveFavoriteDoCommand", options: {}, I: RemoveFavoriteDoCommandRequest, O: RemoveFavoriteDoCommandResponse },
    { name: "ListFavoriteDoCommands", options: {}, I: ListFavoriteDoCommandsRequest, O: ListFavoriteDoCommandsResponse },
    { name: "ReorderFavoriteDoCommands", options: {}, I: ReorderFavoriteDoCommandsRequest, O: ReorderFavoriteDoCommandsResponse }
]);
